/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import cx from 'classnames';
import '@itwin/itwinui-css/css/table.css';
import { useTheme } from '../../utils/index.js';
import { Button } from '../../Buttons/index.js';
const defaultStrings = {
    filter: 'Filter',
    clear: 'Clear',
};
/**
 * Button bar component that should be used in a filter. It already has Filter and Clear buttons.
 * @example
 * <FilterButtonBar setFilter={() => setFilter(text)} clearFilter={clearFilter} />
 */
export const FilterButtonBar = (props) => {
    const { children, setFilter, clearFilter, translatedLabels, className, style, id, } = props;
    const translatedStrings = { ...defaultStrings, ...translatedLabels };
    useTheme();
    return (React.createElement("div", { className: cx('iui-button-bar', className), style: style, id: id },
        children,
        React.createElement(Button, { styleType: 'high-visibility', onClick: setFilter }, translatedStrings.filter),
        React.createElement(Button, { onClick: clearFilter }, translatedStrings.clear)));
};
